export const getCMSIntlVal = (target: any, key: string, Locale: string) => {
  return target[`${key}_${Locale}`] || target[key] || '';
};

export const tCMSLineBreak = (target: string) => {
  return target.replace(/\\n/g, '\n');
};
